import React from "react";
import { Link, useParams } from "react-router-dom";
import BreadcrumbIntegrationLabel from "./BreadcrumbIntegrationLabel";
import type { Integration } from "./Breadcrumbs";

interface IntegrationIdBreadcrumbsProps {
  baseText: React.ReactNode;
  basePath: string;
  integrations?: Integration[];
}

const IntegrationIdBreadcrumbs: React.FC<IntegrationIdBreadcrumbsProps> = ({
  baseText,
  basePath,
  integrations = [],
}) => {
  const { integrationId } = useParams<{ integrationId: string }>();

  if (!integrations?.length) {
    return (
      <div>
        <Link to={basePath}>{baseText}</Link> / . . .
      </div>
    );
  }

  const selectedIntegration = integrations.find(
    (integration) => integration.id === integrationId
  );

  return (
    <span>
      <Link to={basePath}>{baseText}</Link> /{" "}
      <BreadcrumbIntegrationLabel integration={selectedIntegration} />
    </span>
  );
};

export default IntegrationIdBreadcrumbs;
